import script from "./NavMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./NavMenu.vue?vue&type=script&setup=true&lang=js"

import "./NavMenu.vue?vue&type=style&index=0&id=e2cc7d26&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\Vind\\VindBack\\VindBackVueApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2cc7d26"]])

export default __exports__
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBadge,QBtn,QBtnDropdown,QList,QItem,QItemSection});qInstall(script, 'directives', {ClosePopup});
